import React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";

import {
    FormMultiSelect,
    FormDateRangePicker,
} from "../../forms/form-components";

export const AdministratorLoginShortingBlackoutDatesForm = (props) => {
    const datesRequiredValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        if (!value.start) {
            return "Start date is required";
        }

        if (!value.end) {
            return "End date is required";
        }

        return "";
    }

    return (
        <Dialog
            title={props.item.loginShortingBlackoutDatesKey ? "Update Shorting Blackout Dates" : "Add Shorting Blackout Dates"}
            onClose={props.cancel}
            width={"90vw"}
        >
            <Form
                onSubmit={props.save}
                initialValues={props.item}  
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset className={"k-form-fieldset container"}>
                            <div className="row">
                                <div className="col">
                                    <Field
                                        id={"dates"}
                                        name={"dates"}
                                        label={"Blackout dates"}
                                        component={FormDateRangePicker}
                                        validator={datesRequiredValidator}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <Field
                                        id={"excludedTicketingWebsites"}
                                        name={"excludedTicketingWebsites"}
                                        label={"Excluded websites"}
                                        component={FormMultiSelect}
                                        data={props.ticketingWebsites}
                                        textField="name"
                                        dataItemKey="ticketingWebsiteId"
                                    />
                                </div>
                            </div>
                        </fieldset>
                        <div className="k-form-buttons">
                            <Button
                                type={"submit"}
                                themeColor={"primary"}
                            >
                                Save
                            </Button>
                            <Button
                                type={"submit"}
                                onClick={props.cancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </FormElement>
                )}
            />
        </Dialog>
    );
}